<template>
  <div>
    <TopNavbar />
    <div
      v-if="!loading" style="overflow: hidden"
    >
      <div class="row">
      <div
        class="col-md-8 col-md-offset-2 text-center p-10"
      >
        <br />
        <h1 class="f-normal f-16 title-menu">{{ title }} Portal</h1>
        <br />
        <div class="min-height" v-if="checkVisibility()">
          <div class="row">
          <div style="margin-bottom: 50px; display: flex; flex-wrap: wrap; justify-content: center">
            <div v-for="(element, index) in homeButtonsDetails" :key="index" v-if="element.visible" @click="() => { if (element.path === '/login') redirectLogin()}" class="col-sm-5 col-xs-10" :class="calculatePositionOnGrid(homeButtonsDetails,index)">
              <router-link
                role="link"
                :to="element.path === '/login' ? '' : element.path"
              >
                <div class="dashboard-box">
                  <p><img :src="'static/img/dashboard/' + element.image + '.png'" alt="img" /></p>
                  <p class="textButton">{{computeCaption(element.caption, $store.state.lang.value.toLowerCase())}}</p>
                </div>
              </router-link>
            </div>
          </div>
          </div>
            <el-tooltip  placement="bottom" effect="light" :disabled="disabled">
            <div slot="content" class="color:green">
              <span style="color:#51A7E9;">Branch Name: </span>{{versionDetails.branchName}}
              <span style="color:#51A7E9;"> Version Tag: </span> {{versionDetails.versionTag}} <br/>
              <span style="color:#51A7E9;"> Branch Name: </span>{{this.branch}}
              <span style="color:#51A7E9;"> Version Tag: </span> {{this.version}} <br/>
              <span style="color:#51A7E9;"> Build Timestamp: </span> {{this.buildTimeStamp}}
            </div>
            <span>v2.16</span>
          </el-tooltip>
        </div>
        <div v-else v-loading="true" class="loading min-height"></div>
      </div>
      </div>
    </div>
    <div v-else v-loading="loading" class="loading"></div>
    <navbar v-if="isMobile()"></navbar>
  </div>
</template>

<script>
import {FormatterUtils} from '../../../utils/Formatter'
import LanguageButton from './LanguageButton'
import axios from 'axios'
import { Input, Button, Tooltip, Tag } from 'element-ui'
import {TranslationsUtils} from '../../../utils/Translations'
import {homeButtonUtils} from '../../../utils/HomeButtons'
import TopNavbar from '../Layout/TopNavbar'
import Navbar from '../../Dashboard/Layout/Navbar.vue'
import {ValidationUtils} from '../../../utils/Validation'
export default {
  data () {
    return {
      buildTimeStamp: '',
      version: '',
      branch: '',
      disabled: false,
      versionDetails: {
        branchName: '',
        versionTag: ''
      },
      registerPath: this.$store.state.configs['SINGLE_PAGE_ORDERS'] === true ? '/patient/order' : '/patient/register',
      homeCollectionPath: this.$store.state.configs['SINGLE_PAGE_ORDERS'] === true ? '/patient/order-home-collection' : '/patient/register-home-collection',
      loading: true,
      windowWeight: '',
      fields_en: {
        login: 'Login / Create New Account'
      },
      background: process.env.CLIENT_BACKGROUND,
      backgroundMobile: process.env.CLIENT_BACKGROUND_MOBILE,
      logo: process.env.CLIENT_LOGO
    }
  },
  mixins: [FormatterUtils, TranslationsUtils, homeButtonUtils, ValidationUtils],
  components: {
    LanguageButton,
    [Input.name]: Input,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
    [Tag.name]: Tag,
    TopNavbar,
    Navbar
  },
  async beforeMount () {
    if (this.$route.query.lang !== undefined) {
      this.$store.state.lang.value = this.$route.query.lang
    }
    if (window.location.search.includes('code') && !localStorage.getItem('token')) {
      axios({
        url: process.env.SERVER_URI + '/token',
        method: 'post',
        data: {code: window.location.search.split('=').pop()}
      })
      .then((response) => {
        if (!response.data) {
          window.location.href = this.$store.state.configs.AWS_DOMAIN_NAME + '/login?response_type=code&client_id=' + this.$store.state.configs.AWS_CLIENT_ID + '&redirect_uri=' + this.$store.state.configs.AWS_REDIRECT_URL
        } else {
          localStorage.setItem('token', response.data['token'])
          localStorage.setItem('access_token', response.data['access_token'])
          localStorage.setItem('email', response.data['email'])
          localStorage.setItem('firstName', response.data['given_name'])
          localStorage.setItem('lastName', response.data['family_name'])
          window.location.href = window.origin + '/#/patient/account'
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    } else if (localStorage.getItem('token')) {
      window.location.href = window.origin + '/#/patient/account'
    } else {
      this.loading = false
    }
    window.document.title = this.title + ' Patient Portal - Home'
    await this.translateFields()
    this.getVersion()
    this.buildTimeStamp = document.documentElement.dataset.buildTimestampUtc.replace('T', ' ').slice(0, -5)
  },
  mounted () {
    this.windowWeight = window.innerWidth
    window.addEventListener('resize', () => {
      this.windowWeight = window.innerWidth
    })
  },
  methods: {
    redirectLogin () {
      window.location.href = this.$store.state.configs.AWS_DOMAIN_NAME + '/login?response_type=code&client_id=' + this.$store.state.configs.AWS_CLIENT_ID + '&redirect_uri=' + this.$store.state.configs.AWS_REDIRECT_URL
    },
    translateFields () {
      axios({
        url: process.env.SERVER_URI + '/translation',
        method: 'get'
      })
        .then((response) => {
          this.$store.state.translation = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getVersion () {
      axios({
        url: process.env.SERVER_URI + '/version',
        method: 'get'
      })
      .then((response) => {
        this.versionDetails = response.data
      })
      .catch(function (error) {
        console.log(error)
      })
      if (this.versionDetails.branchName === undefined || this.versionDetails.versionTag === undefined) {
        this.disabled = true
      }
      this.version = process.env.VERSION.substring(0, process.env.VERSION.indexOf('-'))
      this.branch = process.env.BRANCH
    }
  },
  computed: {
    title () {
      return this.$store.state.configs.LAB_NAME
    },
    allow_registration () {
      return this.isTrue(this.$store.state.configs.ALLOW_REGISTRATION)
    },
    allow_results () {
      return this.isTrue(this.$store.state.configs.ALLOW_RESULTS)
    },
    allow_kit_registration () {
      return this.isTrue(this.$store.state.configs.ALLOW_KIT_REGISTRATION)
    },
    allow_go_pass () {
      return this.isTrue(this.$store.state.configs.ALLOW_GO_PASS)
    },
    allow_quick_order () {
      return this.isTrue(this.$store.state.configs.ALLOW_SELF_ORDERING)
    }
  }
}
</script>

<style lang="scss" scoped>
.background {
  background-position: center center;
  background-repeat: no-repeat !important;
  background-attachment: fixed !important;
  background-size: cover !important;
  background-color: white;
  height: 100vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.dashboard-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 25px !important;
  border-radius: 0;
  min-height: 260px;
  border: 1px solid #eaeaea;
  box-shadow: 0px 0px 2px #0000004C;
  padding: 40px 10px 20px;
  transition: 0.4s;
  &:hover {
     background: #F5F8FB;
     border: 1px solid #8FB3D0;
   }
  .textButton {
    color: #51A7E9;
  }
  img{
    height: 100px;
  }
  .textButton{
    color: #757575;
    font-size: 17px;
    font-weight: 500;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    min-height: 30px;
    transition: 0.4s;
  }
}

.container-top-right {
  position: fixed;
  top: 0;
  right: 0;
}


.language-select {
  float: left;
}

hr {
  border-top: 2px solid #c1c1c1;
  position: absolute;
  bottom: 32%;
  width: 100%;
  z-index: 0;
}

.min-height {
  min-height: 155px;
}

.f-16 {
  font-size: 25px;
}

>>> .el-loading-parent--relative {
  height: 100vh;
}

@media screen and (max-width: 1110px) {
  .dashboard-box {
    margin-top: 30px;
    min-height: 240px;
    img {
      height: 80px;
    }
  }
  .w-90 {
    min-height: 155px;
  }
}
@media screen and (max-width: 980px) {
  .dashboard-box {
    margin-top: 30px;
    min-height: 240px;
    img {
      height: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Home.vue